import React from 'react';
import { LEGAL_ENTITY } from './legalEntity';

const E = LEGAL_ENTITY;

const sections = [
  { t: '1. Grievance Redressal', c: `${E.name} (CIN: ${E.cin}) is committed to resolving user complaints promptly and fairly. In accordance with the Information Technology Act, 2000 and the rules thereunder, and the Consumer Protection (E-Commerce) Rules, 2020, we have appointed a Grievance Officer to address complaints regarding the Service, content, payments, subscriptions, refunds, or data privacy.` },
  { t: '2. What You Can Raise', c: 'You may contact the Grievance Officer about any concern including: billing or refund disputes, unauthorised transactions, account or access problems, objectionable or infringing content, privacy or data-rights requests, or any violation of our Terms & Conditions.' },
  { t: '3. How to File a Complaint', c: `Email the Grievance Officer at ${E.grievanceEmail} with: (a) your registered name and email; (b) a clear description of the complaint; (c) any relevant transaction IDs, dates, or screenshots; and (d) the resolution you are seeking. You may also write to the registered address below.` },
  { t: '4. Our Response Commitment', c: `We will acknowledge every complaint within 48 hours of receipt and will endeavour to resolve it within ${E.grievanceResponseDays} (fifteen) days from the date the complaint is received, in line with applicable law. If a complaint requires more time, we will keep you informed of the status and the expected timeline.` },
];

export default function GrievanceOfficer({ onBack }) {
  return (
    <div style={{ minHeight: '100vh', background: '#0a0000', color: '#f0e6cc', fontFamily: "'Barlow', sans-serif", padding: '0 0 60px' }}>
      <div style={{
        position: 'sticky', top: 0, zIndex: 10,
        background: 'rgba(10,0,0,0.95)', borderBottom: '1px solid rgba(212,168,67,0.2)',
        padding: '16px 5%', display: 'flex', alignItems: 'center', gap: 16
      }}>
        <button onClick={onBack} style={{
          background: 'rgba(212,168,67,0.1)', border: '1px solid rgba(212,168,67,0.3)',
          color: '#d4a843', width: 40, height: 40, borderRadius: '50%', cursor: 'pointer', fontSize: 18
        }}>←</button>
        <div style={{ fontFamily: "'Cinzel', serif", fontSize: '1.3em', fontWeight: 900, color: '#f5c842', letterSpacing: 2 }}>
          GRIEVANCE REDRESSAL
        </div>
      </div>

      <div style={{ maxWidth: 760, margin: '0 auto', padding: '32px 5%' }}>
        <p style={{ color: '#8a7060', fontSize: 13, marginBottom: 24 }}>
          Last Updated: August 29, 2026 &nbsp;•&nbsp; {E.name} ({E.website})
        </p>

        {sections.map((s, i) => (
          <div key={i} style={{ marginBottom: 28 }}>
            <h2 style={{
              fontFamily: "'Barlow Condensed', sans-serif", fontSize: '1.15em', fontWeight: 800,
              color: '#f5c842', letterSpacing: 1, marginBottom: 8
            }}>{s.t}</h2>
            <p style={{ fontSize: 14, lineHeight: 1.7, color: '#d8c8a8' }}>{s.c}</p>
          </div>
        ))}

        {/* Grievance Officer contact card */}
        <div style={{
          marginTop: 8, padding: '24px', background: 'rgba(212,168,67,0.06)',
          border: '1px solid rgba(212,168,67,0.2)', borderRadius: 10
        }}>
          <div style={{
            fontFamily: "'Barlow Condensed', sans-serif", fontSize: '11px', fontWeight: 800,
            letterSpacing: 2, color: '#c8902a', textTransform: 'uppercase', marginBottom: 12
          }}>Grievance Officer</div>
          <p style={{ fontSize: 14, lineHeight: 1.8, color: '#e8d8b8', margin: 0 }}>
            <strong style={{ color: '#f5c842' }}>{E.grievanceOfficerName}</strong><br />
            {E.name}<br />
            {E.address}<br />
            Email: <a href={`mailto:${E.grievanceEmail}`} style={{ color: '#d4a843' }}>{E.grievanceEmail}</a><br />
            <span style={{ color: '#c8b89a' }}>Response commitment: within {E.grievanceResponseDays} days of receipt.</span>
          </p>
        </div>
      </div>
    </div>
  );
}
